import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { ToastModule } from 'primeng/toast';
import { AppComponent } from './app.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authorizationInterceptor } from './core/interceptors/authorization.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { tenantInterceptor } from './core/interceptors/tenant.interceptor';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PipesModule } from './shared/pipes.module';

@NgModule({
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    BrowserAnimationsModule,
    ToastModule,
    ConfirmDialogModule,
    PipesModule
  ],
  declarations: [AppComponent],
  providers: [
    MessageService,
    ConfirmationService,
    provideEnvironmentNgxMask(),
    provideHttpClient(
      withInterceptors([
        authorizationInterceptor,
        errorInterceptor,
        tenantInterceptor
      ])
    )
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
